"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = exports.TitleLoader = exports.TableLoaderWrapper = void 0;
const styles_1 = require("@mui/material/styles");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
exports.TableLoaderWrapper = (0, styles_1.styled)(Box_1.default)({
    width: "100%",
    height: "100%",
});
exports.TitleLoader = (0, styles_1.styled)(Skeleton_1.default)({
    height: "36px",
    margin: "24px 0",
});
exports.Table = (0, styles_1.styled)(Skeleton_1.default)({
    height: "100%",
});
